/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const GraphicIcon = ({ width = 24, height = 24, hidden = false, title = 'Graphic' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M33 14h-9V1.385a.482.482 0 0 0-.481-.5H23.5a.494.494 0 0 0-.35.147L1.091 23.146a.5.5 0 0 0 .354.854h8.838A7.909 7.909 0 0 0 10 26a7.976 7.976 0 0 0 14.89 4H33a1 1 0 0 0 1-1V15a1 1 0 0 0-1-1ZM4.828 22 22 4.828V14h-3a1 1 0 0 0-1 1v3a7.967 7.967 0 0 0-6.891 4ZM18 32a6 6 0 1 1 6-6 6.007 6.007 0 0 1-6 6Z"
    />
  </svg>`;
};
